import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";


export function cn(...inputs: any[]) {
  return twMerge(clsx(inputs));
}

  export const chunkArray = (array: any[], chunkSize: number) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  export const formatDate = (date: string) => {
    const dateObj = new Date(date);
    return dateObj.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric"
  });
};

  